module.exports = __webpack_public_path__ + "static/media/sebastian2.9c1c4e9f.jpg";